import axios from 'axios';

// APIのベースURLを設定
const apiClient = axios.create({
  baseURL: `${process.env.VUE_APP_API_BASE_URL}/api`, // .envファイルから取得、またはデフォルト
  headers: {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${localStorage.getItem('jwtToken') || ''}`, // 初回セット
  },
  timeout: 10000, // タイムアウトを10秒に設定
});

// リクエストインターセプター
apiClient.interceptors.request.use(
  (config) => {
    // 必要であればここでJWTトークンをヘッダーに付与
    const token = localStorage.getItem('jwtToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// レスポンスインターセプター
apiClient.interceptors.response.use(
  (response) => {
    // レスポンスデータをそのまま返す
    return response;
  },
  (error) => {
    // エラーハンドリング
    if (error.response) {
      const { status, data } = error.response;
      if (status === 401) {
        // 認証エラー時の処理（例: ログイン画面にリダイレクト）
        alert('タイムアウトです。再ログインしてください。');
        window.location.href = '/login'; // 例: ログインページにリダイレクト
      } else if (status === 500) {
        alert('サーバーエラーが発生しました。');
      } else {
        alert(data.message || 'エラーが発生しました。');
      }
    } else if (error.request) {
      // リクエストがサーバーに到達しなかった場合
      alert('ネットワークエラーが発生しました。接続を確認してください。');
    } else {
      alert('予期しないエラーが発生しました。');
    }
    return Promise.reject(error);
  }
);

export default apiClient;
